
import { Component, Vue, Prop } from 'vue-property-decorator';
import SignUp from '~/components/UIComponents/SignUp.vue';
import { ThemeName } from '~/store/types';

@Component({
  components: { SignUp },
})
export default class SignUpRow extends Vue {
  @Prop({ type: String, default: "I'm in" })
  readonly buttonText!: string;
  @Prop({ type: String, default: 'purple' })
  readonly btnStyle!: 'purple' | 'white';

  theme = ThemeName.DARK;
}
